import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Trans, useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import { green } from "@mui/material/colors";
import { styled, useTheme } from "@mui/material/styles";
import Radio from "@mui/material/Radio";

import { PhoneMaskCustom } from "../../_helpers/PhoneNumberHelper";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";

import PropTypes from "prop-types";
import { brandColors } from "../brandedComponent/BrandedColors";
import Cookies from "universal-cookie";
import { LifeSafer } from "../../_helpers/BrandConstants";
import {
  registerEnrollee,
  enrolleeUpdate,
} from "../../_redux/actions/enrolleeActions";
import { connect } from "react-redux";
import ContinueButton from "./ContinueButton";
import { useToaster } from "../toaster/MuiToasterProvider";
import useMediaQuery from "@mui/material/useMediaQuery";
import { utilities } from "@/_helpers";
import { useParams } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import HomeIcon from "@mui/icons-material/Home";
import Autocomplete from "@mui/material/Autocomplete";
import Link from "@mui/material/Link";
import { getEnrollmentCodeStateDefaultByType } from "../../_api/enrolleeApi";
import { getRegionId, getRegions } from "../../_api/dataListApi";

// Replace this URL if Matt provides a different Europe privacy-policy link.
const EUROPE_PRIVACY_POLICY_URL = "https://www.lifesafer.eu/privacy-policy/";

const getRegionIdValue = (region = {}) =>
  region.regionId ?? region.RegionId ?? region.regionID ?? region.RegionID;

const getRegionName = (region = {}) =>
  region.name ??
  region.Name ??
  region.description ??
  region.Description ??
  region.regionName ??
  region.RegionName ??
  "";

const getRegionItems = (response, property) => {
  if (Array.isArray(response)) return response;
  const pascalCaseProperty = `${property[0].toUpperCase()}${property.slice(1)}`;
  return response?.[property] ?? response?.[pascalCaseProperty] ?? [];
};

const normalizeRegionName = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase();

const GreenRadio = styled(Radio)(() => ({
  color: green[400],
  "&.Mui-checked": {
    color: green[600],
  },
}));

const ContactInfo = ({
  handleUpdate,
  goToBackStep,
  submitting,
  setSubmitting,
  contactInfoForm,
  pereferedContact,
  setPreferedContact,
  isLoaded,
  deviceLocationType,
  activeStep,
  europeMode = false,
  enrolleeData
}) => {
  const { t } = useTranslation();
  const { storyName } = useParams();

  const [preferedContactError, setPreferedContactError] = useState(false);
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  // const deviceType = localStorage.getItem("devicetype");
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const [violationCountry, setViolationCountry] = useState(null);
  const [europeCountries, setEuropeCountries] = useState([]);
  const [countriesLoading, setCountriesLoading] = useState(false);
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  const toast = useToaster();
  const theme = useTheme();
  const isBelow998 = useMediaQuery(theme.breakpoints.down(998));
  // const isBelow925 = useMediaQuery(theme.breakpoints.down(925));
  const isEuropeStory = storyName?.toLowerCase() === "europe";

  const isLifeSaferia = window.location.href
    .toLowerCase()
    .includes("lifesaferisa");

  const countryCode = sessionStorage.getItem("LSCountryCode");
  const enrollNow = cookies.get("EnrollNow") || {};
  const {
    UTM_source,
    UTM_medium,
    UTM_campaign,
    GA_clientid,
    gclid,
    UserAgent,
    IPAddress,
    wbraid,
    gbraid,
    fbclid,
    fbp,
    ttclid,
    rdt_cid,
    Page: rawPage,
    URL,
  } = enrollNow;
  const showZip =
    storyName === "speed" || storyName?.toLowerCase() === "isa volunteer";
  const Page = rawPage?.substring(0, 150) || "";

  useEffect(() => {
    if (!europeMode) return undefined;

    let isActive = true;
    setCountriesLoading(true);

    const regionSearchObj =
      countryCode === "AU"
        ? { regionTypeId: 7, description: "Oceania" }
        : countryCode === "EU"
          ? { regionTypeId: 7, description: "European Union" }
          : { regionTypeId: 7, description: "North America" };

    getRegionId(regionSearchObj)
      .then((region) => {
        const regionId =
          typeof region === "number"
            ? region
            : (region?.regionId ?? region?.RegionId);

        if (!regionId) throw new Error("Country region ID was not returned.");
        return getRegions(regionId);
      })
      .then((regionsResponse) => {
        if (!isActive) return;

        const regions = getRegionItems(regionsResponse, "countries");
        const countries = regions
          .map((region) => ({
            label: getRegionName(region),
            code: region?.code ?? region?.Code ?? "",
            countryId: region?.countryId ?? region?.CountryId,
            regionId: getRegionIdValue(region),
          }))
          .filter((country) => country.label && country.regionId)
          .filter(
            (country, index, values) =>
              values.findIndex(
                (value) => String(value.regionId) === String(country.regionId),
              ) === index,
          )
          .sort((first, second) => first.label.localeCompare(second.label));

        setEuropeCountries(countries);
          let prefillViolationCountry=countries?.find((x)=>x?.regionId===enrolleeData?.convictionCountryId);

        setViolationCountry((currentCountry) => {
          if (currentCountry?.regionId) return currentCountry;

          const savedCountry =
          prefillViolationCountry?.label ||
            currentCountry ||
            enrolleeUser?.violationCountry ||
            enrolleeUser?.countryOfViolation;
          const enrollmentCountryRegionId =
            enrollmentCodeData?.convictionRegionID ??
            enrollmentCodeData?.ConvictionRegionID;
          return (
            countries.find(
              (country) =>
                normalizeRegionName(country.label) ===
                normalizeRegionName(savedCountry),
            ) ||
            countries.find(
              (country) =>
                enrollmentCountryRegionId &&
                String(country.regionId) === String(enrollmentCountryRegionId),
            ) ||
            null
          );
        });
      })
      .catch(() => {
        if (isActive) setEuropeCountries([]);
      })
      .finally(() => {
        if (isActive) setCountriesLoading(false);
      });


    return () => {
      isActive = false;
    };
  }, [countryCode, europeMode,enrolleeData]);


  // let timedOut = false;
  let zipCodeEnrollmentCodeId = null;

  let regionCode = countryCode;

  let lat = 0;
  let lng = 0;
  let addr1 = null;
  let addr2 = null;
  let cityGoogleData = null;
  let stateGoogleData = null;
  let countyGoogleData = null;

  let googleMapData = null;
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = contactInfoForm;

  const resolveEuropeConvictionDefaults = async () => {
    const countryRegions = await getRegions(violationCountry.regionId);
    const states = getRegionItems(countryRegions, "states");
    const defaultState =
      states.find(
        (state) =>
          normalizeRegionName(getRegionName(state)) ===
          normalizeRegionName(violationCountry.label),
      ) || states[0];

    if (!defaultState) {
      throw new Error(`No state is configured for ${violationCountry.label}.`);
    }

    const convictionStateId = getRegionIdValue(defaultState);

    if (!convictionStateId) {
      throw new Error(
        `The default state for ${violationCountry.label} has no region ID.`,
      );
    }

    const stateRegions = await getRegions(convictionStateId);
    const defaultCounty = getRegionItems(stateRegions, "counties")[0];
    const convictionCountyId = getRegionIdValue(defaultCounty);

    if (!convictionCountyId) {
      throw new Error(`${t("error.noCountyConfigured")} ${violationCountry.label}.`);
    }

    return {
      defaultState,
      defaultCounty,
      convictionStateId,
      convictionCountyId,
    };
  };

  const onSubmit = async (data) => {
    if (europeMode && !violationCountry) {
      setPreferedContactError(true);
      toast.error(
        t(
          "europe.completeRequiredFields",
          // "Please complete all required fields before continuing.",
        ),
      );
      return false;
    }
    if (data.call_me_out) {
      console.log("honeypot error", preferedContactError);
      toast.error(t("error.honeyPotError"));
      setSubmitting(false);
      return false;
    }

    let europeConvictionDefaults = null;
    if (europeMode) {
      setSubmitting(true);
      try {
        europeConvictionDefaults = await resolveEuropeConvictionDefaults();
      } catch (error) {
        console.error("Unable to load Europe conviction defaults", error);
        toast.error(`${t("toasts.updateFailed")} ${error?.message || ""}`);
        setSubmitting(false);
        return false;
      }
    }

    if (showZip) {
      try {
        const createGoogleMapData = (
          lat,
          lng,
          addr1,
          addr2,
          city,
          county,
          state,
        ) => ({
          homeLat: lat,
          homeLong: lng,
          homeAddr1: addr1,
          homeAddr2: addr2,
          city,
          county: county ? county.replace(/['"]/g, "") : county,
          state,
        });

        try {
          setSubmitting(true);
          const locationData = await withTimeout(getLocation(data.zip), 5000); //await getLocation(data.zip);
          if (
            locationData?.results?.length > 0 &&
            processGeocodeResponse(locationData)
          ) {
            googleMapData = createGoogleMapData(
              lat,
              lng,
              addr1,
              addr2,
              cityGoogleData ?? null,
              countyGoogleData ?? null,
              stateGoogleData ?? null,
            );
          }
        } catch (error) {
          console.error("Error fetching location:", error);
        }

        if (!googleMapData?.state) {
          toast.error(t("steps.unableToLoadLocation"));
          setSubmitting(false);
          return false;
        }

        const result = await getEnrollmentCodeStateDefaultByType(
          stateGoogleData,
          "ISA Volunteer",
          brand,
        );

        if (result?.enrollmentCodeId) {
          zipCodeEnrollmentCodeId = result?.enrollmentCodeId;
          cookies.set("lsEnrollmentCode", result, {
            path: "/",
            sameSite: "strict",
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    let updateData = {
      step: "Contact",
      FirstName: data.firstName,
      LastName: data.lastName,
      HomePhone: data.cellPhone,
      Email: data.email,
      contactPreference: pereferedContact || "Phone",
      BrandIdentifier: brand,
      EnrollmentCodeId:
        zipCodeEnrollmentCodeId ||
        enrolleeUser?.enrollmentCodeId ||
        enrolleeUser?.EnrollmentCodeId ||
        enrollmentCodeData?.enrollmentCodeId ||
        enrollmentCodeData?.EnrollmentCodeId,
      CellPhone: data.cellPhone,
      deviceType: isLifeSaferia
        ? "Speed"
        : storyName?.toLowerCase() === "speed" ||
            storyName?.toLowerCase() === "isa volunteer"
          ? "Speed"
          : utilities?.deviceInfo(
              storyName?.toLowerCase() === "location"
                ? deviceLocationType ||
                    enrolleeUser?.deviceType ||
                    enrollNow?.DeviceType ||
                    enrolleeUser?.clientTypeId
                : enrolleeUser?.clientTypeId ||
                    enrolleeUser?.deviceType ||
                    enrollNow?.DeviceType ||
                    deviceLocationType,
            )?.deviceType,
      EnrolleeId: enrolleeUser?.enrolleeId,
      protPlan: enrolleeUser?.protPlan,
      utM_source: UTM_source || null,
      utM_medium: UTM_medium || null,
      utM_campaign: UTM_campaign || null,
      gA_clientid: GA_clientid || null,
      zip: data.zip || enrolleeUser?.zip || null,
      gclID: gclid || null,
      userAgent: UserAgent || null,
      ipAddress: IPAddress || null,
      wbraid: wbraid || null,
      gbraid: gbraid || null,
      fbclid: fbclid || null,
      fbp: fbp || null,
      ttclid: ttclid || null,
      rdt_cid: rdt_cid || null,
      page: Page || null,
      // referURL: URL || null,
      referURL: URL?.slice(0, 500) || null,
      dlState: enrolleeUser?.dlState || enrolleeUser?.DlState || null,
      dlNum: enrolleeUser?.dlNum || enrolleeUser?.DlNum || "CE - NEED",
      country: enrolleeUser?.country || enrolleeUser?.Country,
      ...googleMapData,
      ...(europeMode
        ? {
            country: violationCountry.code,
            // state: getRegionName(europeConvictionDefaults?.defaultState),
            // county: getRegionName(europeConvictionDefaults?.defaultCounty),
            violationCountry: violationCountry.label,
            countryOfViolation: violationCountry.label,
            violationCountryCode: violationCountry.code,
            violationCountryId: violationCountry.countryId,
            ConvictionStateID: europeConvictionDefaults?.convictionStateId,
            ConvictionCountyID: europeConvictionDefaults?.convictionCountyId,
            convictionState: getRegionName(
              europeConvictionDefaults?.defaultState,
            ),
            convictionCounty: getRegionName(
              europeConvictionDefaults?.defaultCounty,
            ),
            convictionCountryId:violationCountry?.regionId,
          }
        : {}),
    };
    handleUpdate("Contact", updateData);
  };

  const onInvalid = () => {
    if (!europeMode) return;
    if (!violationCountry) setPreferedContactError(true);
    toast.error(
      t(
        "europe.completeRequiredFields",
        "Please complete all required fields before continuing.",
      ),
    );
  };

  const handleRadioChange = (event) => {
    setPreferedContact(event.target.value);
    setPreferedContactError(false);
  };

  const validateZip = (value) => {
    if (value?.length == 0) {
      return t("body.zipRequired");
    }
    // if (
    //   (countryCode === "US" || countryCode === "EU") &&
    //   /^[0-9]{5}$/.test(value)
    // ) {
    //   return true;
    // } else if (countryCode === "AU" && /^[/^[0-9]{4}$/.test(value)) {
    //   return true;
    // }

    if (/^[0-9]{5}$/.test(value)) {
      return true;
    }

    return t("steps.zipInvalid");
  };

  const processGeocodeResponse = (response) => {
    if (!response || !response.results || response.results.length === 0) {
      return false;
    }
    lat = response.results[0].geometry.location.lat();
    lng = response.results[0].geometry.location.lng();

    const addressComponents = response.results[0].address_components;
    const formatted_address = response.results[0].formatted_address;

    addr1 = addressComponents.find((comp) =>
      comp.types.includes("street_number"),
    )?.long_name
      ? `${
          addressComponents.find((comp) => comp.types.includes("street_number"))
            ?.long_name
        } ${
          addressComponents.find((comp) => comp.types.includes("route"))
            ?.long_name
        }`
      : null;
    if (formatted_address) {
      addr1 = formatted_address.substr(0, formatted_address.indexOf(","));
    }
    addr2 = addressComponents.find((comp) =>
      comp.types.includes("subpremise"),
    )?.long_name;

    cityGoogleData = addressComponents.find((comp) =>
      comp.types.includes("locality"),
    )?.long_name;

    countyGoogleData = addressComponents.find((comp) =>
      comp.types.includes("administrative_area_level_2"),
    )?.long_name;

    stateGoogleData = addressComponents.find((comp) =>
      comp.types.includes("administrative_area_level_1"),
    )?.short_name;

    return true;
  };

  // const { isLoaded } = useJsApiLoader({
  //   // id: "google-map-script",
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
  // });

  const getLocation = async (address) => {
    if (
      !window.google ||
      !window.google.maps ||
      !window.google.maps.Geocoder ||
      !isLoaded
    ) {
      console.error("Google Maps API not loaded");
      return [];
    }

    let geocoder = new window.google.maps.Geocoder();
    try {
      const response = await geocoder.geocode({
        address: address,
        region: regionCode || "USA",
      });
      return response;
    } catch (error) {
      console.error("Error in geocode request:", error);
      return [];
    }
  };

  function withTimeout(promise, timeout = 5000) {
    let timer;
    const timeoutPromise = new Promise((_, reject) => {
      timer = setTimeout(() => {
        reject(new Error("Request timed out"));
      }, timeout);
    });
    return Promise.race([promise, timeoutPromise]).finally(() => {
      clearTimeout(timer);
    });
  }

  useEffect(() => {
    reset({
      firstName: enrolleeUser?.firstName || enrolleeUser?.FirstName || null,
      lastName: enrolleeUser?.lastName || enrolleeUser?.LastName || null,
      email: enrolleeUser?.email || enrolleeUser?.Email || null,
      cellPhone: enrolleeUser?.cellPhone || enrolleeUser?.CellPhone || null,
      zip: enrolleeUser?.zip || enrolleeUser?.Zip || null,
      preferedContact: null,
      call_me_out: null,
    });
  }, [activeStep]);

  return (
    <>
      <div>
        <form
          className="form"
          onSubmit={handleSubmit(onSubmit, onInvalid)}
          style={{
            width: "100%",
            marginBottom: "40px",
            display: "flex",
            justifyContent: "center",
            maxWidth: "900px",
          }}
        >
          <Grid
            container
            alignItems="start"
            justifyContent="center"
            sx={{
              width: "100%",
              marginTop: "25px",
            }}
            spacing="25px"
          >
            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              <TextField
                style={{ width: "100%", maxWidth: "300px" }}
                variant="outlined"
                id="firstName"
                size="small"
                label={t("quickLink.firstName")}
                name="firstName"
                placeholder={t("quickLink.firstName")}
                error={!!errors.firstName}
                disabled={submitting}
                helperText={errors.firstName ? errors.firstName.message : ""}
                {...register("firstName", {
                  required: {
                    value: true,
                    message: t("quickLink.firstNameError"),
                  },
                  pattern: {
                    value: /^[A-Za-z']+$/i,
                    message: t("intro.firstNameInvalid"),
                  },
                })}
                slotProps={{
                  input: {
                    startAdornment: <PersonIcon className="inputIco" />,
                  },
                }}
              />
            </Grid>

            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              <TextField
                style={{ width: "100%", maxWidth: "300px" }}
                variant="outlined"
                id="lastName"
                size="small"
                label={t("quickLink.lastName")}
                name="lastName"
                placeholder={t("quickLink.lastName")}
                error={!!errors.lastName}
                disabled={submitting}
                helperText={errors.lastName ? errors.lastName.message : ""}
                {...register("lastName", {
                  required: {
                    value: true,
                    message: t("intro.lastNameRequired"),
                  },
                  validate: (value) => {
                    if (!value || !value.trim()) {
                      return t("intro.lastNameError");
                    }

                    const trimmedValue = value.trim();
                    if (trimmedValue !== value) {
                      return t("intro.lastNameError");
                    }

                    if (/\s\s+/.test(trimmedValue)) {
                      return t("intro.lastNameError");
                    }

                    const spaceCount = (trimmedValue.match(/ /g) || []).length;
                    if (spaceCount > 2) {
                      return t("intro.lastNameError");
                    }

                    const apostropheCount = (trimmedValue.match(/'/g) || [])
                      .length;
                    if (apostropheCount > 1) {
                      return t("intro.lastNameError");
                    }

                    if (/--+/.test(trimmedValue)) {
                      return t("intro.lastNameError");
                    }

                    if (
                      trimmedValue.endsWith("-") ||
                      trimmedValue.endsWith(" -")
                    ) {
                      return t("intro.lastNameError");
                    }

                    if (
                      trimmedValue.startsWith("-") ||
                      trimmedValue.startsWith("- ")
                    ) {
                      return t("intro.lastNameError");
                    }

                    const nameParts = trimmedValue
                      .split(/[\s-]+/)
                      .filter((part) => part.length > 0);

                    if (nameParts.length > 3) {
                      return t("intro.lastNameError");
                    }

                    const allLetters = nameParts.every((part) =>
                      /^[a-zA-Z]+(?:'[a-zA-Z]+)?$/.test(part),
                    );
                    if (!allLetters) {
                      return t("intro.lastNameError");
                    }

                    if (nameParts.length === 2 && trimmedValue.includes("-")) {
                      const validTwoPartPattern =
                        /^[a-zA-Z]+([\s]\*-[\s]\*[a-zA-Z]+)$/i;

                      if (!validTwoPartPattern.test(trimmedValue)) {
                        return t("intro.lastNameError");
                      }
                    }

                    return true;
                  },
                  setValueAs: (value) => value,
                })}
                slotProps={{
                  input: {
                    startAdornment: <PersonIcon className="inputIco" />,
                  },
                }}
              />
            </Grid>
            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              <TextField
                style={{ width: "100%", maxWidth: "300px" }}
                variant="outlined"
                id="cellPhone"
                size="small"
                label={t("steps.cellNumber")}
                name="cellPhone"
                // placeholder={t("steps.cellNumber")}
                placeholder="(---) --- ----"
                error={!!errors.cellPhone}
                disabled={submitting}
                helperText={errors.cellPhone ? errors.cellPhone.message : ""}
                {...register("cellPhone", {
                  required: {
                    value: true,
                    message: t("quickLink.cellPhoneError"),
                  },
                  validate: (value) => {
                    if (countryCode === "EU") {
                      if (
                        value.replace(/\D/g, "").length > 3 &&
                        value.replace(/\D/g, "").length < 15
                      ) {
                        return true;
                      } else {
                        return t("quickLink.cellPhoneError");
                      }
                    } else {
                      if (
                        value.replace(/\D/g, "").length === 10 ||
                        value.replace(/\D/g, "").length === 11
                      ) {
                        return true;
                      } else {
                        return t("quickLink.cellPhoneError");
                      }
                    }
                  },
                })}
                InputProps={{
                  inputComponent: PhoneMaskCustom,
                  startAdornment: <PhoneIphoneIcon className="inputIco" />,
                }}
              />
            </Grid>

            <Grid style={{ maxWidth: "300px", width: "100%" }}>
              <TextField
                style={{ width: "100%", maxWidth: "300px" }}
                variant="outlined"
                id="email"
                size="small"
                label={t("intro.emailLabel")}
                name="email"
                placeholder={t("steps.emailPlaceholder")}
                error={!!errors.email}
                disabled={submitting}
                helperText={errors.email ? errors.email.message : ""}
                {...register("email", {
                  required: {
                    value: true,
                    message: t("intro.emailAddressRequired"),
                  },
                  pattern: {
                    value:
                      /^[A-Z0-9](?:[A-Z0-9]|[._%+-](?=[A-Z0-9]))*@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: t("intro.emailAddressError"),
                  },
                })}
                slotProps={{
                  input: {
                    startAdornment: <EmailIcon className="inputIco" />,
                  },
                }}
              />
            </Grid>

            {showZip && (
              <Grid
                size={{ xs: 12, md: 12 }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextField
                  variant="outlined"
                  fullWidth
                  size="small"
                  id="zip"
                  label={`${t("steps.homeZip")}`}
                  name="zip"
                  placeholder={t("payments.zipCode")}
                  disabled={submitting}
                  error={!!errors.zip}
                  helperText={errors.zip ? errors.zip.message : ""}
                  style={{ width: "100%", maxWidth: "300px" }}
                  {...register("zip", {
                    validate: (value) => {
                      if (value?.length === 0 || value === null) {
                        return t("body.zipRequired");
                      }
                      return validateZip(value);
                    },
                  })}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <HomeIcon />
                      </InputAdornment>
                    ),
                  }}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start" className="inputIco">
                          <HomeIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </Grid>
            )}

            {/* {!isBelow925 && showZip ? (
              <Grid style={{ maxWidth: "300px", width: "100%" }}></Grid>
            ) : null} */}

            {!europeMode && (
              <Grid style={{ maxWidth: "300px", width: "100%" }}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    color: `${brandColors[brand].primary}`,
                  }}
                >
                  {t("steps.preferContacted")}
                </Typography>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: { xs: "16px", md: "45px", lg: "45px" },
                  }}
                >
                  <FormControlLabel
                    sx={{
                      mr: 0,
                      "& .MuiFormControlLabel-label": {
                        fontWeight: "bold",
                      },
                    }}
                    control={
                      <GreenRadio
                        id="preferedContact"
                        name="preferedContact"
                        value="Phone"
                        checked={pereferedContact === "Phone"}
                        onChange={handleRadioChange}
                        disabled={submitting}
                      />
                    }
                    label={t("steps.phoneCall")}
                  />
                  <FormControlLabel
                    sx={{
                      mr: 0,
                      "& .MuiFormControlLabel-label": {
                        fontWeight: "bold",
                      },
                    }}
                    control={
                      <GreenRadio
                        id="preferedContact"
                        name="preferedContact"
                        value="Text"
                        checked={pereferedContact === "Text"}
                        onChange={handleRadioChange}
                        disabled={submitting}
                      />
                    }
                    label={t("steps.textMessage")}
                  />
                </Grid>
              </Grid>
            )}
            {europeMode && (
              <Grid style={{ maxWidth: "300px", width: "100%" }}>
                <Autocomplete
                  options={europeCountries}
                  value={violationCountry}
                  getOptionLabel={(option) => option?.label || ""}
                  isOptionEqualToValue={(option, value) =>
                    String(option?.regionId) === String(value?.regionId)
                  }
                  loading={countriesLoading}
                  disabled={submitting || countriesLoading}
                  onChange={(_, value) => {
                    setViolationCountry(value);
                    setPreferedContactError(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label={t(
                        "europe.violationCountry",
                        "Country of Violation",
                      )}
                      placeholder={t("europe.chooseCountry")}
                      error={preferedContactError && !violationCountry}
                      helperText={
                        preferedContactError && !violationCountry
                          ? t("europe.countryRequired", "Country is required")
                          : ""
                      }
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
              </Grid>
            )}
            <ContinueButton
              goToBackStep={
                storyName?.toLowerCase() !== "location" ? goToBackStep : ""
              }
              submitting={submitting}
              showForwardIcon={isEuropeStory ? false : true}
              isLongWidth={europeMode}
              isFullWidth={europeMode}
            />
            <Grid
              sx={{
                maxWidth: isBelow998 ? "300px" : "900px",
                paddingX: "10px",
              }}
            >
              {europeMode ? (
                <Typography
                  sx={{
                    border: `2px solid ${brandColors[brand].primary}`,
                    borderRadius: "10px",
                    padding: "8px",
                    fontSize: "10px",
                    fontWeight: 400,
                    color: "black",
                  }}
                >
                  <Trans
                    i18nKey="europe.contactConsentMessage"
                    components={{
                      privacyPolicy: (
                        <Link
                          href={EUROPE_PRIVACY_POLICY_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                        />
                      ),
                    }}
                  />
                </Typography>
              ) : (
                <Typography
                  sx={{
                    border: `2px solid ${brandColors[brand].primary}`,
                    borderRadius: "10px",
                    padding: "8px",
                    fontSize: "10px",
                    fontWeight: 400,
                    color: "black",
                  }}
                >
                  {t("steps.contactConsentMessage")}
                </Typography>
              )}
            </Grid>

            <input
              type="checkbox"
              id="call_me_out"
              name="call_me_out"
              style={{ display: "none" }}
              tabIndex="-1"
              autoComplete="off"
              {...register("call_me_out")}
            />
          </Grid>
        </form>
      </div>
    </>
  );
};

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {
  registerEnrollee,
  enrolleeUpdate,
};

ContactInfo.propTypes = {
  handleUpdate: PropTypes.func,
  goToBackStep: PropTypes.func,
  submitting: PropTypes.bool,
  setSubmitting: PropTypes.func,
  contactInfoForm: PropTypes.func,
  pereferedContact: PropTypes.object,
  setPreferedContact: PropTypes.func,
  isLoaded: PropTypes.bool,
  deviceLocationType: PropTypes.string,
  activeStep: PropTypes.number,
  europeMode: PropTypes.bool,
  enrolleeData:PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfo);
